export default "__VITE_ASSET__LHuAm3Jf__"